import { LOCALITIES } from "../data/site";

export const Marquee = () => (
  <div
    className="marquee relative overflow-hidden border-y border-[#E7E3D8] bg-white/70 py-5"
    aria-label="Localities we cover between Borivali and Andheri"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {LOCALITIES.map((place) => (
            <span
              key={`${copy}-${place}`}
              className="flex items-center gap-8 px-8 text-sm font-semibold uppercase tracking-[0.3em] text-navy/50"
            >
              {place}
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
